import banderaMexico from './assets/bandera-mexico.png';
import banderaAfrica from './assets/bandera-sudafrica.png'

export const STAGE_CODES = [
  { code: "GROUP_STAGE", label: "Fase de grupos" },
  { code: "ROUND_OF_32", label: "Dieciseisavos" },
  { code: "ROUND_OF_16", label: "Octavos" },
  { code: "QUARTER_FINALS", label: "Cuartos" },
  { code: "SEMI_FINALS,THIRD_PLACE", label: "Semifinal y 3°" },
  { code: "FINAL", label: "Final" },
];

export const GROUPS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];

export const FLAG = {
  México: banderaMexico,
  Sudáfrica: banderaAfrica,
};

export const GROUP_A_MATCHES = {
  "Fecha 1": {
    date: "11 DE JUNIO",
    matches: [
      { time: "20:00 / ARG", teamA: "México", teamB: "Sudáfrica", stadium: "Estadio Banorte, Ciudad de México" },
      { time: "20:00 / ARG", teamA: "Corea del Sur", teamB: "Por definir", stadium: "Estadio Akron, Guadalajara" },
    ],
  },
  "Fecha 2": {
    date: "18 DE JUNIO",
    matches: [
      { time: "20:00 / ARG", teamA: "México", teamB: "Sudáfrica", stadium: "Estadio Mercedes-Benz, Atlanta" },
      { time: "19:00 / ARG", teamA: "México", teamB: "Corea del Sur", stadium: "Estadio Akron, Guadalajara" },
    ],
  },
  "Fecha 3": {
    date: "24 DE JUNIO",
    matches: [
      { time: "20:00 / ARG", teamA: "Por definir", teamB: "México", stadium: "Estadio Banorte, Ciudad de México" },
      { time: "19:00 / ARG", teamA: "Sudáfrica", teamB: "Corea del Sur", stadium: "Estadio BBVA, Monterrey" },
    ],
  },
};
